<template>
  <div class="setting-btn" @click="openList">
    <img src="@/assets/img/icon/setting.png" alt="" />
    <span>{{ $ln('設定') }}</span>
  </div>
</template>

<script>
export default {
  name: 'settingSelectedBlock',
  props: {
    isOpenSetting: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      isOpenList: false
    }
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() {},
  methods: {
    /**
     * 開啟設定選單
     */
    openList() {
      this.isOpenList = this.isOpenSetting
      this.isOpenList = !this.isOpenList
      this.$emit('getOpenSettingStatus', this.isOpenList)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
